<template>
    <div>
        <div class="faq-card">
            <div class="header" @click="$emit('click')" tabindex="0">
                <div class="row">
                    <div class="col-10 col-md-11">
                        {{question}}
                    </div>
                    <div class="col-2 col-md-1">
                        <img src="@/assets/Close.svg" v-if="open"/>
                        <img src="@/assets/Open.svg" v-else/>
                    </div>
                </div>
            </div>
            <div class="faq-question" v-if="open" v-html="answer">
            </div>
        </div>
        <hr/>
    </div>
</template>

<script>
    import $ from "jquery"

    export default {
        name: "FAQCard",
        props: ["id", "question", "answer", "open"],
        mounted() {
            this.setUpLinks();
        },
        updated() {
            this.setUpLinks();
        },
        methods: {
            setUpLinks() {
                const allLinks = $("a");
                allLinks.off("click");
                allLinks.click((e) => {
                    e.preventDefault();
                    if (e.currentTarget.href.indexOf(location.host) > -1) {
                        return this.$emit("nav", e.currentTarget.href);
                    }
                    this.$communicator.openExternalBrowser(e.currentTarget.href);
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../scss/color_palette";

    hr {
        margin: 0 12px;
    }

    .faq-card {
        margin: 10px 20px;
        overflow-wrap: break-word;
        overflow: hidden;
        & .header {
            color: black;
            -webkit-user-select: none; /* webkit (safari, chrome) browsers */
            -moz-user-select: none; /* mozilla browsers */
            -khtml-user-select: none; /* webkit (konqueror) browsers */
            -ms-user-select: none; /* IE10+ */
            font-size: 20px;
            font-weight: 600;
            padding: 18px 0;
            & > .swj-question {
                width: 85%;
            }
            &:focus {
                outline: none;
            }
        }

        .faq-question {
            margin-bottom: 22px;
            font-size: 17px;
            color: rgb(77, 77, 77);
            ::v-deep a {
                text-decoration: underline;
                font-weight: 600;
            }
            ::v-deep img {
                max-width: 100%;
            }
            ::v-deep figcaption {
                font-size: 15px;
                margin-top: 10px;
            }
            ::v-deep figure {
                margin-bottom: 5px;
            }
            ::v-deep ul {
                display: block;
                list-style-type: disc;
                margin-block-start: 1px;
                margin-block-end: 1px;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                padding-inline-start: 20px;
            }
            ::v-deep ol {
                display: block;
                list-style-type: decimal;
                margin-block-start: 1px;
                margin-block-end: 1px;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                padding-inline-start: 20px;
            }
            ::v-deep p, ::v-deep ol, ::v-deep dl, ::v-deep ul {
                margin-top: 0;
                margin-bottom: 1rem;
            }
        }
    }
</style>